import { BREAK_FINISHED, BREAK_IN_PROGRESS } from '@/consts/services'

export default {
  breaks: (state) => {
    return _.get(state, ['active', 'breaks'], [])
  },
  /**
   * La pause suivante ou la pause active
   * @param state
   * @param getters
   * @returns {*}
   */
  nextBreak: (state, getters) => {
    const { breaks } = getters
    return breaks.find((b) => b.status < BREAK_FINISHED)
  },
  isPaused (state, getters) {
    return _.get(getters, ['nextBreak', 'status']) === BREAK_IN_PROGRESS
  }
}
